import { type FC, useRef } from "react";

import { GlobalMetricsTooltip } from "~/feature/globalMetrics/components/GlobalMetricsTooltip";
import type { IGetGlobalMetricsResponseBody } from "~/feature/globalMetrics/types";

import * as Styled from "./GlobalMetricsLine.styles";
import { GlobalMetricsLineItems } from "./GlobalMetricsLineItems";
import { useMarqueeDuration } from "./useMarqueeDuration";

interface IGlobalMetricsLineProps {
  data: IGetGlobalMetricsResponseBody | null;
}

export const GlobalMetricsLine: FC<IGlobalMetricsLineProps> = ({ data }) => {
  const groupRef = useRef<HTMLDivElement>(null);
  const duration = useMarqueeDuration(groupRef, [data]);

  return (
    <Styled.Container>
      <Styled.MarqueeViewport>
        <Styled.MarqueeTrack $duration={duration}>
          <Styled.MarqueeGroup ref={groupRef}>
            <GlobalMetricsLineItems data={data} groupId="primary" />
          </Styled.MarqueeGroup>
          <Styled.MarqueeGroup aria-hidden>
            <GlobalMetricsLineItems data={data} groupId="duplicate" />
          </Styled.MarqueeGroup>
        </Styled.MarqueeTrack>
      </Styled.MarqueeViewport>
      <Styled.TooltipSlot>
        <GlobalMetricsTooltip />
      </Styled.TooltipSlot>
    </Styled.Container>
  );
};
